import { useSessionSettings } from '@hotjar/webapp/features/Settings/hooks';
import { CAPTURE_MODE } from '@hotjar/webapp/features/Settings/types';
import { useCurrentSite } from '@hotjar/site';
import { usePlanRepository } from '@hotjar/webapp/hooks/usePlanRepository';
import { useTrackingCodeState } from '@hotjar/webapp/hooks/useTrackingCode';

export enum TrackingState {
  LOADING,
  DISABLED,
  SUCCESS,
  WARNING,
  NOT_INSTALLED,
}

export function useTrackingState(): TrackingState {
  const { data: currentSite, isLoading: isCurrentSiteLoading } = useCurrentSite();
  const { data: sessionSettings, isLoading: isSessionSettingsLoading } = useSessionSettings(
    currentSite?.id,
  );
  const trackingCodeState = useTrackingCodeState();
  const planRepository = usePlanRepository();
  const hasCC = currentSite
    ? planRepository.byId(currentSite.effectivePlanId).ccDailyAllowance > 0
    : false;
  const isInstalled = trackingCodeState.installed;

  if (isCurrentSiteLoading || isSessionSettingsLoading || !currentSite) {
    return TrackingState.LOADING;
  }

  if (!isInstalled) {
    return TrackingState.NOT_INSTALLED;
  }

  if (hasCC && sessionSettings?.sessionCaptureMode === CAPTURE_MODE.OFF) {
    return TrackingState.DISABLED;
  }

  return trackingCodeState.isActive ? TrackingState.SUCCESS : TrackingState.WARNING;
}
